import { FC, ReactNode } from 'react';
import classNames from 'classnames';

import { ReactComponent as TrashIcon } from 'assets/images/icons/trash.svg';

import { Button } from 'ui/Button';

type PropTypes = {
  children: ReactNode;
  title?: ReactNode;
  onRemove?: () => void;
  className?: string;
  type?: 'default' | 'error';
};

const Card: FC<PropTypes> = ({ children, title, className, onRemove, type = 'default' }) => {
  return (
    <div className={classNames('card', `card--${type}`, className)}>
      {(!!title || !!onRemove) && (
        <div className="card-headline">
          {!!title && typeof title === 'string' && (
            <h2 className="card-title">{title}</h2>
          )}

          {!!title && typeof title !== 'string' && title}

          {!!onRemove && (
            <Button onClick={onRemove} variant="icon" size="small-square" type="button">
              <TrashIcon />
            </Button>
          )}
        </div>
      )}

      <div className="card-content">{children}</div>
    </div>
  );
};

export default Card;
